module.exports = __webpack_public_path__ + "static/partner-hxkj-fb62e4f3159d07502d80ac676ab3a017.png";